var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _circle, _path12, _g2, _path13, _path14, _path15, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 209 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#797882",
    fillRule: "nonzero",
    d: "M151.782 57.202H19.706v49.762h146.028l-13.952-49.762z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#acacb2",
    d: "M19.706 57.204H98.882V106.965H19.706z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565c",
    d: "M57.377 30.928H88.061V51.856H57.377z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2e30",
    d: "M72.915 30.928H88.061V51.856H72.915z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d2217",
    fillRule: "nonzero",
    d: "M88.059 37.902H57.375a6.976 6.976 0 010-13.951h30.684a6.976 6.976 0 110 13.951z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565c",
    d: "M27.612 6.978H47.944V57.204H27.612z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2e30",
    d: "M37.715 6.978H47.946000000000005V57.204H37.715z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#de3205",
    fillRule: "nonzero",
    d: "M47.944 13.952H27.612a6.976 6.976 0 010-13.952h20.332a6.976 6.976 0 110 13.952z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#acacb2",
    fillRule: "nonzero",
    d: "M160.154 64.178H18.776a6.976 6.976 0 110-13.951h141.378a6.975 6.975 0 010 13.951z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3e42",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.605 79.031h-4.623a2.79 2.79 0 01-2.79-2.791v-4.622a2.79 2.79 0 012.79-2.791h4.623a2.79 2.79 0 012.79 2.791v4.623a2.79 2.79 0 01-2.79 2.79zM62.617 79.031h-4.623a2.79 2.79 0 01-2.79-2.791v-4.622a2.79 2.79 0 012.79-2.791h4.623a2.79 2.79 0 012.79 2.791v4.623a2.79 2.79 0 01-2.79 2.79zM79.628 79.031h-4.622a2.79 2.79 0 01-2.791-2.791v-4.622a2.79 2.79 0 012.791-2.791h4.622a2.79 2.79 0 012.791 2.791v4.623a2.79 2.79 0 01-2.791 2.79zM96.641 79.031h-4.623a2.79 2.79 0 01-2.79-2.791v-4.622a2.79 2.79 0 012.79-2.791h4.623a2.79 2.79 0 012.79 2.791v4.623a2.79 2.79 0 01-2.79 2.79zM113.653 79.031h-4.623a2.79 2.79 0 01-2.79-2.791v-4.622a2.79 2.79 0 012.79-2.791h4.623a2.79 2.79 0 012.79 2.791v4.623a2.79 2.79 0 01-2.79 2.79zM130.665 79.031h-4.623a2.79 2.79 0 01-2.79-2.791v-4.622a2.79 2.79 0 012.79-2.791h4.623a2.79 2.79 0 012.79 2.791v4.623a2.79 2.79 0 01-2.79 2.79zM54.631 93.943h-4.623a2.79 2.79 0 01-2.79-2.79V86.53a2.79 2.79 0 012.79-2.79h4.623a2.79 2.79 0 012.79 2.79v4.623a2.79 2.79 0 01-2.79 2.79zM74.433 91.153a2.79 2.79 0 01-2.79 2.79H67.02a2.79 2.79 0 01-2.791-2.79V86.53a2.79 2.79 0 012.791-2.79h4.623a2.79 2.79 0 012.79 2.79v4.623zM91.445 91.153a2.79 2.79 0 01-2.79 2.79h-4.623a2.79 2.79 0 01-2.79-2.79V86.53a2.79 2.79 0 012.79-2.79h4.623a2.79 2.79 0 012.79 2.79v4.623zM105.667 93.943h-4.623a2.79 2.79 0 01-2.79-2.79V86.53a2.79 2.79 0 012.79-2.79h4.623a2.79 2.79 0 012.79 2.79v4.623a2.79 2.79 0 01-2.79 2.79zM122.679 93.943h-4.623a2.79 2.79 0 01-2.79-2.79V86.53a2.79 2.79 0 012.79-2.79h4.623a2.79 2.79 0 012.79 2.79v4.623a2.79 2.79 0 01-2.79 2.79zM142.481 91.153a2.79 2.79 0 01-2.79 2.79h-4.623a2.79 2.79 0 01-2.79-2.79V86.53a2.79 2.79 0 012.79-2.79h4.623a2.79 2.79 0 012.79 2.79v4.623z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e3",
    fillRule: "nonzero",
    d: "M173.565 158.168a28.653 28.653 0 01-23.837 12.757H33.302c-14.523 0-26.748-10.867-28.451-25.29L.042 104.892a6.048 6.048 0 011.488-4.732 6.053 6.053 0 014.525-2.033h196.223a6.056 6.056 0 015.039 9.414l-33.752 50.627z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#acacb2",
    fillRule: "nonzero",
    d: "M98.882 98.127v72.798h50.845a28.65 28.65 0 0023.837-12.757l33.751-50.627a6.052 6.052 0 00.3-6.216 6.053 6.053 0 00-5.338-3.198H98.882z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.983,
    cy: 119.29,
    r: 9.069,
    fill: "#2d2e30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565c",
    fillRule: "nonzero",
    d: "M35.983 128.356a9.068 9.068 0 110-18.137v18.137z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#2d2e30"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.432,
    cy: 119.29,
    r: 9.069
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.884,
    cy: 119.29,
    r: 9.069
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.331,
    cy: 119.29,
    r: 9.069
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.783,
    cy: 119.29,
    r: 9.069
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d2217",
    fillRule: "nonzero",
    d: "M185.688 139.983H4.184l.668 5.653c.034.288.079.572.122.858h176.373l4.341-6.511z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#de3205",
    fillRule: "nonzero",
    d: "M98.882 139.983H4.184l.668 5.653c.034.288.079.572.121.858h93.909v-6.511z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e3",
    fillRule: "nonzero",
    d: "M98.882 50.226H18.776a6.976 6.976 0 000 13.952h80.106V50.226z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#57565c",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.432 128.356a9.068 9.068 0 01-9.068-9.068 9.068 9.068 0 019.068-9.069v18.137zM98.882 128.356a9.068 9.068 0 110-18.137v18.137zM130.332 128.356a9.068 9.068 0 110-18.137v18.137zM161.781 128.356a9.068 9.068 0 01-9.068-9.068 9.068 9.068 0 019.068-9.069v18.137z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.46e8acce323810d6752328ebb699ffea.svg";
export { ForwardRef as ReactComponent };